<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="heading-large mt-0">
                        <span v-if="isReenteringNegotiation">Re-enter</span>
                        <span v-else>Revise</span>
                        Negotiation
                    </h1>
                    <button type="button" data-dismiss="modal" class="modal-close" aria-label="Cancel" @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div v-if="!showRenegotiationConfirmed && !showNegotiationPlacedConfirmed">
                    <div v-if="!showReenterConfirmation" class="modal-body negotiation-selection bg-olf-light-greyish-blue">
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="select-fuel-type">Product</label>
                                <div class="select-wrapper white-field">
                                    <select id="select-fuel-type" v-model="negotiation.fuelType" disabled>
                                        <option :value="negotiationSelected.fuel_id">
                                            {{negotiationSelected.fuel_id | fueltype}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="select-measurement">Measurement</label>
                                <div class="select-wrapper white-field">
                                    <select id="select-measurement" v-model="negotiation.measurement">
                                        <option :value="measurementType" v-for="(measurementType, index) in measurements" :key="index">
                                            {{measurementType | fuelmeasurementtype}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="serviceType !== 'BUNKERING'">
                            <div v-if="serviceType == 'SPOT'" class="form-group col-md-6">
                                <label>Terminal</label>
                            <v-select 
                                :options="getTerminalChanges" label="name" v-model="negotiation.terminal" placeholder="Search terminal here..." :clearable= "false">
                            </v-select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="select-collection-period">Lifting Period</label>
                                <div class="select-wrapper white-field">
                                    <select id="select-collection-period" v-model="negotiation.collectionTime">
                                        <option :value="collectionPeriod" v-for="(collectionPeriod,index) in collectionPeriodList" :key="index">
                                            {{collectionPeriod | collectiondaysformat}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="select-negotiation-period">Time Valid</label>
                                <div class="select-wrapper white-field">
                                    <select id="select-negotiation-period" v-model="negotiation.period">
                                        <option :value="period" v-for="(period,index) in negotiationPeriods" :key="index" :disabled="index == 0">
                                            <span v-if="index == 0">Select Time Valid</span>
                                            <span v-else>{{period | negotiationperiodformat}}</span>
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="select-negotiation-type">Pricing Method</label>
                                <div class="select-wrapper white-field">
                                    <select id="select-negotiation-type" v-model="negotiation.type">
                                        <option :value="type" v-for="(type,index) in negotiationTypes" :key="index">
                                            {{type | offertype}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!showReenterConfirmation" class="modal-body">
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label>Your Price (ppl)</label>
                                <cleave class="form-control" v-model="negotiation.price" 
                                    :options="numeralPositive" @blur.native="setPriceFormat(negotiation.price, 'price')"></cleave>
                            </div>
                            <div class="form-group col-md-6">
                                <div v-if="negotiation.type == 'TRACKING'">
                                    <label>Max Price (ppl)</label>
                                    <cleave class="form-control" v-model="negotiation.maxPrice" :options="numeralPositive"
                                        @blur.native="setPriceFormat(negotiation.maxPrice, 'max-price')"></cleave>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label>Volume/L</label>
                                <cleave class="form-control" v-model="negotiation.quantity" 
                                    :options="numeralPositive"></cleave>
                            </div>
                            <div class="form-group col-md-6">
                                <label>Best Price (ppl)</label>
                                <input class="form-control" :value="bestPrice > 0 ? bestPrice.toFixed(2) : '0.00' " disabled />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 form-group">
                                <template v-if="serviceType !== 'BUNKERING'">
                                    <label>Buyer Reference (Optional)</label>
                                    <input class="form-control" v-model="negotiation.reference" />
                                </template>
                                <template v-else>
                                    <label>Keyfuels/UK Fuels account number</label>
                                    <input class="form-control" v-model="negotiation.reference" @keypress="isNumberKeyEvent($event)" />
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="!showReenterConfirmation" class="modal-body total bg-olf-light-greyish-blue">
                        <div class="row">
                            <div class="col-md-6">
                                TOTAL
                            </div>
                            <div class="col-md-6">
                                <span class="float-left">
                                    {{negotiation.quantity | volumeformat}} Litres
                                </span>
                                <span class="float-right">
                                    £{{negotiation.quantity * negotiation.price/100 | priceformat}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="!showReenterConfirmation" class="modal-footer">
                        <span class="error-message float-left">{{error}}</span>
                        <button v-if="isReenteringNegotiation" class="btn btn-primary float-right ml-0" 
                            @click="reenterNegotiation($event)" :disabled="error || isPlacingNegotiation">
                            <span v-if="isPlacingNegotiation">Processing...</span>
                            <span v-else>Re-enter negotiation</span>
                        </button>
                        <button v-else class="btn btn-primary float-right ml-0" 
                            @click="confirmNegotiationRevision()" :disabled="error || isPlacingNegotiation">
                            <span v-if="isPlacingNegotiation">Processing...</span>
                            <span v-else>Save Changes</span>
                        </button>
                    </div>

                    <!-- If buyer hit "Save" after original negotiation has expired, display this confirmation screen -->
                    <div v-if="showReenterConfirmation" class="modal-body">
                        <div class="col-md-12">
                            <div class="row reenter-confirmation">
                                <h5 class="modal-title">This negotiation has expired. Do you wish to re-enter this as a new negotiation into the market?</h5>
                                <div class="buttons-wrapper">
                                    <button class="btn btn-danger mr-2" @click="closeModal()">Do not re-enter negotiation</button>
                                    <button class="btn btn-primary" @click="reenterNegotiation($event)" :disabled="isPlacingNegotiation">Re-enter negotiation</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Confirmation screen after revising/re-entering negotiation -->
                <div v-else>
                    <div class="modal-body confirmation text-center">
                        <h5 class="status-message">
                            {{renegotiationStatusMessage !== '' ? renegotiationStatusMessage : placeNegotiationStatusMessage}}
                        </h5>
                        <button v-if="!isReenteringNegotiation" class="btn btn-tertiary mr-2" @click="closeModal()">Close</button>
                        <button v-else class="btn btn-primary mx-auto d-block" @click="goToNegotiation()">Go to Negotiation</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { isNumberKeyEvent } from "@/util/util";

export default {
    data(){
        return {
            showReenterConfirmation: false,
            isReenteringNegotiation: false,
            measurements: ['STANDARD', 'AMBIENT'],
            collectionPeriodList: [0, 1, 2, 3, 7, 30],
            negotiationPeriods: [-1, 15, 30, 60, 99],
            negotiationTypes: ['FIXED', 'TRACKING'],
            negotiation: {
                fuelType: -1,
                measurement: -1,
                terminal: {_id: -1},
                collectionTime: -1,
                period: -1,
                type: -1,
                price: Number(0).toFixed(2),
                maxPrice: Number(0).toFixed(2),
                quantity: 0,
                reference: ''
            },
            isPlacingNegotiation: false,
            isNumberKeyEvent,
        }
    },
    computed: {
        ...mapState('inputCheckers',['numeralPositive', 'maxExpiryTime']),
        ...mapState('login', ['userLoggedIn']),
        ...mapState('negotiation', ['negotiationSelected', 'showRenegotiationConfirmed', 'renegotiationStatusMessage',
            'showNegotiationPlacedConfirmed', 'placeNegotiationStatusMessage', 'negotiationsList']),
        ...mapState('offers', ['liveOffers']),
        ...mapGetters('fuelsType', ['getFuelsType']),
        ...mapGetters('terminals', ['getTerminalChanges']),
        ...mapGetters('negotiation', ['getFuelPricesChanges']),
        ...mapGetters('metadata', ['productConfig']),
        error: {
            get: function(){
                if (this.negotiation.fuelType == -1){
                    return 'Select a product'
                }
                else if (this.negotiation.measurement == -1){
                    return 'Select a fuel measurement'
                }
                else if (this.serviceType == 'SPOT' && (this.negotiation.terminal._id == -1 || !this.negotiation.terminal)){
                    return 'Select a terminal'
                }
                else if (this.serviceType !== 'BUNKERING' && this.negotiation.collectionTime == -1){
                    return 'Select a lifting period'
                }
                else if (this.negotiation.period == -1){
                    return 'Please select how long your negotiation will be valid for'
                }
                else if (this.negotiation.type == -1){
                    return 'Select a pricing method'
                }
                else if (this.negotiation.price <= 0){
                    return 'Enter a valid price'
                }
                else if (this.negotiation.type == 'TRACKING' && Number(this.negotiation.price) > Number(this.negotiation.maxPrice)){
                    return 'Max Price cannot be less than Your Price'
                }
                else if (this.negotiation.quantity <= 0 || !Number.isInteger(Number(this.negotiation.quantity))){
                    return 'Volume must be an integer greater than 0'
                }
                else if (this.serviceType === "BUNKERING" && this.negotiation.reference === '') {
                    return 'Enter an Account Number';
                }
            }
        },
        trackedPrice: {
            get: function(){
                let fuel = ''
                let price = 0

                if (this.negotiation.type == 'TRACKING'){
                    fuel = this.getFuelPricesChanges.find(fuel => 
                        fuel.fuel_id == this.negotiation.fuelType)

                    /* Let's put an error prevention here: 
                        in case user selects pricing method as "Tracking" first before selecting any fuel type, 
                        so that we are not returning an error */
                    if (fuel){
                        price = fuel.basePrice
                    }

                    return price
                }
            }
        },
        bestPrice: {
            get: function(){
                let matchingOffersList = []
                let offerPricesList = []
                let lowestPrice = 0

                if ((this.negotiation.fuelType !== -1 || this.negotiation.terminal) && this.liveOffers){
                    matchingOffersList = this.liveOffers.filter(offer => {
                        /* Decide whether to check 'SPOT' or 'BUNKERING' offers, then filter the offers list accordingly */
                        if (this.serviceType == 'SPOT'){
                            /* Diesel/Blended Diesel */
                            if (this.negotiation.fuelType == this.productConfig.DieselId){
                                return offer.storage_type_id == 'SPOT' && 
                                    (offer.fuel_id == this.productConfig.DieselId || 
                                    offer.fuel_id == this.productConfig.BlendedDieselBioId) &&
                                    offer.terminal_id == this.negotiation.terminal._id
                            }

                            /* Gasoil/Blended Gasoil */
                            else if (this.negotiation.fuelType == this.productConfig.GasoilId){
                                return offer.storage_type_id == 'SPOT' && 
                                    (offer.fuel_id == this.productConfig.GasoilId || 
                                    offer.fuel_id == this.productConfig.BlendedGasoilId) &&
                                    offer.terminal_id == this.negotiation.terminal._id
                            }

                            /* Kerosene */
                            else {
                                return offer.storage_type_id == 'SPOT' && 
                                    offer.fuel_id == this.negotiation.fuelType && 
                                    offer.terminal_id == this.negotiation.terminal._id
                            }
                        }
                        else {
                            /* UK Fuels */
                            if (this.negotiation.fuelType == this.productConfig.UkFuelsId){
                                return offer.storage_type_id == 'BUNKERING' && offer.network_id == 'UK'
                            }
                            
                            /* Keyfuels */
                            else {
                                return offer.storage_type_id == 'BUNKERING' && offer.network_id == 'KEY'
                            }
                        }
                    })
                    
                    /* Map the prices of each offer in the list */
                    matchingOffersList.forEach(offer => {
                        offerPricesList.push(offer.price)
                    })

                    /* Find the lowest price in the list and return it as 'Best Price' */
                    if (offerPricesList.length > 0){
                        lowestPrice = Math.min(...offerPricesList)
                    }

                    return lowestPrice
                }
            }
        },
        serviceType : {
            get: function(){
                if (this.negotiationSelected){
                    return this.getFuelsType.find(fuel => fuel._id == this.negotiationSelected.fuel_id).type
                }
            }
        }
    },
    created(){
        this.updateShowRenegotiationConfirmed(false)
        this.updateShowNegotiationPlacedConfirmation(false)
        
        // Decide whether this is re-entering or revising a negotiation
        this.isReenteringNegotiation = new Date() > new Date(this.negotiationSelected.expires) || this.negotiationSelected.status_id !== 'ACTIVE'? 
            true : false

        /* Populates the modal with the current negotiation's data */
        this.negotiation.fuelType = this.negotiationSelected.fuel_id
        this.negotiation.measurement = this.negotiationSelected.fuel_measurement_id
        this.negotiation.terminal = this.negotiationSelected.terminal_id ?
            this.negotiationSelected.terminal : null
        this.negotiation.collectionTime = this.negotiationSelected.collectionTime
        this.negotiation.type = this.negotiationSelected.type_id
        this.negotiation.price = this.negotiationSelected.type_id == 'FIXED' ?
            // Check whether live price has exceeded max price or not
            this.negotiationSelected.price.toFixed(2) : this.negotiationSelected.livePrice.toFixed(2)
        this.negotiation.maxPrice = this.negotiationSelected.maxPrice.toFixed(2)
        this.negotiation.quantity = this.negotiationSelected.quantity
        this.negotiation.reference = this.negotiationSelected.reference

        /* If this is revising, then pre-select the original negotiation's expiry period */
        if (!this.isReenteringNegotiation){
            if (this.negotiationSelected.negotiation_period_id == -1){
                this.negotiation.period = 99
            }
            else {
                let timeValid = this.negotiationSelected.negotiation_period_id/60
                this.negotiation.period = Number(timeValid)
            }
        }
    },
    methods: {
        ...mapMutations('negotiation', ['SELECT_TAB']),
        ...mapActions('negotiation', ['updateShowRenegotiateModal', 'reviseActiveNegotiation', 'placeNegotiation', 
            'updateShowRenegotiationConfirmed', 'updateShowNegotiationPlacedConfirmation', 'selectNegotiation']),
        setPriceFormat: function(price, element){
            if (element == 'max-price'){
                this.negotiation.maxPrice = Number(price).toFixed(2)
            }
            else {
                this.negotiation.price = Number(price).toFixed(2)
            }
        },
        confirmNegotiationRevision: function(){
            this.isPlacingNegotiation = true
            const moment = require('moment')

            let revision = {
                fuel_id: this.negotiation.fuelType,
                quantity: Number(this.negotiation.quantity),
                price: this.negotiation.type == 'FIXED' ? 
                    Number(this.negotiation.price) : (Number(this.negotiation.price) - Number(this.trackedPrice)),
                maxPrice: this.negotiation.type == 'FIXED' ? Number(this.negotiation.price) : Number(this.negotiation.maxPrice),
                terminal_id: this.serviceType == 'SPOT' ? this.negotiation.terminal._id : null,
                fuel_measurement_id: this.negotiation.measurement,
                collectionTime: this.negotiation.collectionTime,
                type_id: this.negotiation.type,
                reference: this.negotiation.reference,
                periodId: this.negotiation.period == 99 || (this.negotiation.period !== 99 &&
                    new Date(moment().add(this.negotiation.period, 'minutes').toDate()) > new Date(this.maxExpiryTime))?
                    'EOD' : this.negotiation.period + 'M'
            }

            /* Checks whether negotiation is still active, otherwise display confirmation screen for re-entering negotiation */
            if (new Date() > new Date(this.negotiationSelected.expires)){
                this.isPlacingNegotiation = false
                this.showReenterConfirmation = true
            }
            else {
                const payload = {
                    revisedNegotiation: revision,
                    negotiation_id: this.negotiationSelected._id
                }
                this.reviseActiveNegotiation(payload)
            }
        },
        reenterNegotiation: async function(event){
            this.isPlacingNegotiation = true
            const moment = require('moment')

            let negotiation = {
                userId: this.userLoggedIn.userId,
                fuel_id: this.negotiation.fuelType,
                quantity: Number(this.negotiation.quantity),
                price: this.negotiation.type == 'FIXED' ? 
                    Number(this.negotiation.price) : (Number(this.negotiation.price) - Number(this.trackedPrice)),
                maxPrice: this.negotiation.type == 'FIXED' ? Number(this.negotiation.price) : Number(this.negotiation.maxPrice),
                terminal_id: this.serviceType == 'SPOT' ? this.negotiation.terminal._id : null,
                fuel_measurement_id: this.negotiation.measurement,
                collectionTime: this.negotiation.collectionTime,
                type_id: this.negotiation.type,
                reference: this.negotiation.reference,
                periodId: this.negotiation.period == 99 || (this.negotiation.period !== 99 &&
                    new Date(moment().add(this.negotiation.period, 'minutes').toDate()) > new Date(this.maxExpiryTime))?
                    'EOD' : this.negotiation.period + 'M'
            }
            
            const negotiationPlaced = await this.placeNegotiation(negotiation)
        },
        closeModal: function(){
            $(this.$el).modal('hide')
            this.updateShowRenegotiationConfirmed(false)
            this.updateShowNegotiationPlacedConfirmation(false)
            this.updateShowRenegotiateModal(false)
        },
        goToNegotiation: function(){
            const negotiations = Object.assign([], this.negotiationsList)
            let sortedNegotiationListByCreatedTime = negotiations.sort((a, b) => {
                return new Date(a.created) - new Date(b.created)
            })

            const newNegotiation = sortedNegotiationListByCreatedTime[sortedNegotiationListByCreatedTime.length - 1]

            /* Go to the page */
            this.$router.push({name: 'NegotiationsBuyer'})

            /* Select the negotiation */
            this.selectNegotiation(newNegotiation._id)
            this.SELECT_TAB(0)
            this.closeModal()
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>